export interface OptionFilterItem {
  key: string;
  filter: (number | string)[];
}

export interface OptionFilterCombustion {
  filter: OptionFilterItem[];
}

export interface FilterCombustion {
  stackId?: number[] | null;
  sourceId?: number[] | null;
  area?: string[] | null;
  fuelName?: number[] | null;
}

export interface Emission {
  tvoc: boolean;
  bz: boolean;
  bd: boolean;
  vcm: boolean;
  edc: boolean;
}

export interface ResponseAPI {
  code: number;
  status: string;
  name: string;
  message: string;
  data: {
    combustions: CombustionVocEmission[];
    summary: SummaryVocEmission[];
    total: number;
  };
}

export interface ResponseYearsOfCombustion {
  code: number;
  status: string;
  name: string;
  message: string;
  data: [];
}

export interface dropdownOption {
  key?: string;
  label: string;
  value: string;
}

export interface MonthlyVolume {
  value: number | null;
}

export interface ManualFuelVolume {
  unit: string;

  jan: MonthlyVolume;

  feb: MonthlyVolume;

  mar: MonthlyVolume;

  apr: MonthlyVolume;

  may: MonthlyVolume;

  jun: MonthlyVolume;

  jul: MonthlyVolume;

  aug: MonthlyVolume;

  sep: MonthlyVolume;

  oct: MonthlyVolume;

  nov: MonthlyVolume;

  dec: MonthlyVolume;
}

export interface UnitCombustionVoc {
  [key: string]: {
    combustions: CombustionVocEmission[];
    summary: SummaryVocEmission[];
  };
}

export interface CombustionVocEmission {
  _id?: string;
  companyId: string;
  stackId: number | "";
  sourceId: number | "";
  area: string;
  emission: string;
  fuelName: string;
  fuelType: string;
  year: number | "";
  unit: string;
  statusCalulationEmissionPI: string;
  jan: Number;
  feb: Number;
  mar: Number;
  apr: Number;
  may: Number;
  jun: Number;
  jul: Number;
  aug: Number;
  sep: Number;
  oct: Number;
  nov: Number;
  dec: Number;
}

export interface SummaryVocEmission {
  key: string;
  label: string;
  emission: string;
  jan: number;
  feb: number;
  mar: number;
  apr: number;
  may: number;
  jun: number;
  jul: number;
  aug: number;
  sep: number;
  oct: number;
  nov: number;
  dec: number;
  unit: string;
  total: number;
}

export interface MasterSettings {
  _id: string;
  type: string;
  label: string;
  parentId?: string;
  options: dropdownOption[];
}

export interface Month {
  title: string;
  dataIndex: keyof CombustionVocEmission;
}

type StaticColumns = keyof CombustionVocEmission;

export interface StaticColumnsType {
  label: string;
  key: StaticColumns;
}

export interface Option {
  _id?: string;
  label: string;
  value: string;
}

export interface Master {
  _id: string;
  type: string;
  label: string;
  options: Option[];
}

export interface multipleApprover {
  approverName: String;
  approverUserId: String;
  email: String;
}

export interface StepsApprove {
  stepNo: number;
  stepName: string;
  approverName: string;
  approverUserId: string;
  email: string;
  datetime: string;
  comment: string;
  status: string;
  role: string;
  isDetectUpdateStep: boolean;
  isMultipleApprover: boolean;
  multipleApprover: multipleApprover[];
}

export interface CombustionApprove {
  status: string;
  month: string;
  year: number;
  companyId: string;
  approveNo: number;
  steps: StepsApprove[];
  currentStep: number;
}

export interface ApproveBody {
  userId: string;
  approveId: string;
  comment: string;
  stepApprove: number;
  status: string;
  name: string;
  email: string;
  month: string;
  year: number;
}

export enum ReportStatusEnum {
  PROCESSING = "processing",
  REQUEST = "request",
  APPROVER_1 = "approver_1",
  APPROVER_2 = "approver_2",
  APPROVER_3 = "approver_3",
  REJECT = "reject",
}

export enum StatusStepEnum {
  REQUEST = "request_approval",
  APPROVED = "approved",
  REJECT = "reject",
  WAITING_FOR_APPROVE = "waiting_for_approval",
}

export interface WidthCol {
  jan: string;
  feb: string;
  mar: string;
  apr: string;
  may: string;
  jun: string;
  jul: string;
  aug: string;
  sep: string;
  oct: string;
  nov: string;
  dec: string;
}

export interface WidthColCombustion {
  [key: string]: string;
}
